import { Component } from '@angular/core';
@Component({
  templateUrl: './refresh.component.html',
  standalone:true
})
export class RefreshComponent {
}
